export const REMEMBER_ME = '__rememberMe';
export const PREF_DARK_MODE = '__pref_dark_mode';
export const ANONYMOUS_USER_TOKEN = '__anonUserToken';
export const hasWindow = typeof window !== 'undefined';
export const PERSIST_KEY_RESULTS = 'p2r-store-results';
export const PERSIST_KEY_ZIP = 'p2r-zip';
export const PERSIST_KEY_SKU = 'PERSIST_KEY_SKU';
export const PERSIST_KEY_LAST_METHOD = "PERSIST_KEY_LAST_METHOD";
export const PERSIST_KEY_GEO = 'persisted-geo';
export const status401 = 401;
export const status403 = 403;